interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const baseSchemas = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '成人高清学历提升平台',
      url: 'https://www.chengrengaoqing.com',
      logo: 'https://www.chengrengaoqing.com/logo.png',
      description: '成人高清学历提升平台专为在职人士设计，提供高清视频课程、名师直播辅导与灵活学习方案。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-888-9999',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      sameAs: [
        'https://weibo.com/chengrengaoqing',
        'https://www.zhihu.com/org/chengrengaoqing',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '成人高清学历提升平台',
      url: 'https://www.chengrengaoqing.com',
      description: '在职人士学历提升首选平台，提供成人高考、自学考试、网络教育、国家开放大学等学历提升方案。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.chengrengaoqing.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    BreadcrumbList: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      publisher: {
        '@type': 'Organization',
        name: '成人高清学历提升平台',
      },
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = baseSchemas[type];

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}